import { SelecaoCompraGiro } from "@/components/CompraRapidaGiro";

const STORAGE_KEY = "lojacap:selecaoGiroCheckout";

export function setSelecaoGiroCheckout(selecao: SelecaoCompraGiro): void {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(selecao));
}

export function getSelecaoGiroCheckout(): SelecaoCompraGiro | null {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw) as SelecaoCompraGiro;
    } catch {
        return null;
    }
}

export function clearSelecaoGiroCheckout(): void {
    sessionStorage.removeItem(STORAGE_KEY);
}
